import { useLocation, useParams } from "react-router";
import CredMgmtSetPassword from "../../components/CredMgmtSetPassword/CredMgmtSetPassword";
import MsCredMgmtSetPassword from "../../components/MsCredMgmtSetPassword/MsCredMgmtSetPassword";
import { DaResetPassword } from "../../components/DaResetPassword/DaResetPassword";
function CredMgmtSetPasswordPage() {
  const { tenant } = useParams();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const brand_id = searchParams.get("brand_id");
  const theme = `${tenant}-theme`;

  return (
    <>
      <div className={theme} data-testid="theme-name">
        {tenant === "ms1" && brand_id === "wlms" ? (
          <DaResetPassword />
        ) : tenant === "ms1" ? (
          <MsCredMgmtSetPassword />
        ) : (
          <CredMgmtSetPassword />
        )}
      </div>
    </>
  );
}

export default CredMgmtSetPasswordPage;
